const datePickerStyle = {
    rightMarginIcon: { marginRight: 8 },
    leftMarginIcon: { marginLeft: 8 },
    datePickerIcon: {},
    datePickerContainer: {},
    container: {},
};

export default datePickerStyle;
